import axios from 'axios';

import { ValidateCodeEndpointRequest } from '../pages/api/validate-unlock-code';
import { ProductUnlockGateway, UnlockState } from '../types/Purchasing';

export class ShopifyUnlockGateway implements ProductUnlockGateway<ShopifyProductIdentifier> {
  async unlockProduct(
    identifier: ShopifyProductIdentifier,
    release: string | undefined,
    code: string,
  ): Promise<UnlockState> {
    const url = new URL('/api/validate-unlock-code', window.location.origin);
    const payload: ValidateCodeEndpointRequest = {
      code,
      shopifyProductId: identifier,
      releaseName: release,
    };

    const response = await axios.post<UnlockState>(url.toString(), payload);
    return response.data;
  }
}
